import { render, staticRenderFns } from "./ReportTableDowntimeByTeam.vue?vue&type=template&id=1bbc4bac&"
import script from "./ReportTableDowntimeByTeam.vue?vue&type=script&lang=js&"
export * from "./ReportTableDowntimeByTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports